import type { AsyncThunk } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getFulfilledData } from 'common/helpers'
import type { ProjectId, TabId } from 'common/types'

import {
  addProjectMarkersApi,
  convertMarkersToPointsApi,
  getMarkersByFieldIdAndNameApi,
} from '../../api'
import type { ActiveEntity, FieldId } from '../../types'
import { deleteElementsToTrashByName, deleteElementToTrashByNameForWell } from '../signalR'
import type { AppDispatch, AppThunk } from '../store'

export const getMarkersAndAddToProject =
  (
    projectId: ProjectId,
    fieldId: FieldId,
    markerNames: string[],
    callback: (count: number) => void,
  ): AppThunk =>
  async () => {
    const markers = markerNames.map(name => getMarkersByFieldIdAndNameApi(fieldId, name))
    const markerData = await getFulfilledData(markers)
    await addProjectMarkersApi(
      projectId,
      markerData.flatMap(markers => markers.map(marker => marker.id)),
    )
    callback(markerData.length)
  }

export const deleteMarkerFromProjectWells: AsyncThunk<
  void,
  {
    projectId: ProjectId
    tabId: TabId
    wellId?: string
    markerEntity: ActiveEntity
  },
  { dispatch: AppDispatch }
> = createAsyncThunk(
  'markers/deleteFromProject',
  ({ projectId, wellId, tabId, markerEntity }, { dispatch }) => {
    if (!markerEntity.entityName) {
      throw new Error('У удаляемого маркера нет имени')
    }

    if (wellId) {
      dispatch(
        deleteElementToTrashByNameForWell(
          projectId,
          wellId,
          markerEntity.entityName,
          'Marker',
          tabId,
        ),
      )
    } else {
      dispatch(deleteElementsToTrashByName(projectId, markerEntity.entityName, 'Marker', tabId))
    }
  },
)

export const convertMarkersToPoints =
  (markerName: string, projectId: ProjectId): AppThunk =>
  () => {
    convertMarkersToPointsApi(markerName, projectId)
  }
